import type { FileItemProps } from "./FileItem";
import { FileItem } from "./FileItem";
import type { FileUploadFile } from "./types";

export type FileListProps = {
	files: FileUploadFile[];
	onRemoveFile: FileItemProps["onRemoveFile"];
};

export const FileList = ({ files, onRemoveFile }: FileListProps) => {
	return (
		<div className="flex flex-col gap-2">
			{files.map((x) => (
				<FileItem key={x.key} onRemoveFile={onRemoveFile} file={x} isInteractive />
			))}
		</div>
	);
};
